<template>
  <div class="navigation-layout">
    <v-app light>
      <v-navigation-drawer
          right
          enable-resize-watcher
          v-model="drawer" app>
        <v-list>
          <v-list-tile @click="goTo('/')">
            <v-list-tile-title>장르 검색하기</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="goTo('/easy-to-use')">
            <v-list-tile-title>앱처럼 사용하기</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="goTo('/question')">
            <v-list-tile-title>사용 문의하기</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar fixed app flat :class="{'elevation-1': !isScrollTop}">
        <div class="title" @click="goTo('/')">넷플릭스 장르 검색</div>
        <v-spacer></v-spacer>
        <v-toolbar-side-icon class="left-menu" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      </v-toolbar>
      <v-content>
        <v-container fluid class="pa-0">
          <slot></slot>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>

  export default {
    components: {
    },
    props: {
    },
    data () {
      return {
        drawer: false,
        isScrollTop: true,
      }
    },
    mounted () {
      window.addEventListener('scroll', this.setIsScrollTop);
    },
    destroyed () {
      window.removeEventListener('scroll', this.setIsScrollTop);
    },
    methods: {
      setIsScrollTop () {
        this.isScrollTop = window.scrollY <= 0;
      },
      goTo (path) {
        this.$router.push({path})
      },
    },
  }
</script>

<style lang="scss" scoped>
  .navigation-layout {
    width: 100%;
    height: 100%;
  }
  .title {
    cursor: pointer;
    user-select: none;
  }
</style>
